import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import contentUsageNotice from '../config/contentUsageNotice';

const hiddenPrefixes = ['/battle', '/battleroom'];

const AppLegalFooter = () => {
  const location = useLocation();
  const hideFooter = hiddenPrefixes.some((prefix) => location.pathname.startsWith(prefix));

  if (hideFooter) {
    return null;
  }

  return (
    <footer className="border-t border-amber-700/20 bg-slate-950/90 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
          <div className="max-w-4xl space-y-1">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-amber-300">Reference & trademark notice</p>
            <p className="text-sm leading-6 text-slate-200">{contentUsageNotice.shortFooterNotice}</p>
            <p className="text-xs leading-5 text-slate-400">{contentUsageNotice.compactFooterDetail}</p>
          </div>
          <div className="md:pl-6">
            <Link
              to="/legal/sources"
              className="inline-flex items-center rounded-full border border-amber-300/30 px-4 py-2 text-sm font-medium text-amber-200 transition hover:border-amber-200/50 hover:bg-amber-300/10 hover:text-amber-100"
            >
              {contentUsageNotice.footerLinkLabel}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppLegalFooter;
